import { Col, Image, Row, Container } from "react-bootstrap";
import { useState } from "react";
import {
  CultureContainer,
  Footer,
} from "../../components/index";
import bgImg from "../../assets/about/aboutus.webp";
import { OurStory } from "../../components/our-story";
import { QueryModal } from "../../components/queryModal";
import { ScrollSlider } from "../../components/scroll-slider";


// Team member images
import man1 from "../../assets/man1.jpeg";
import man2 from "../../assets/man2.jpg";
import man3 from "../../assets/man3.jpg";
import man4 from "../../assets/man4.jpg";
import man5 from "../../assets/man5.jpg";
import man6 from "../../assets/man6.jpg";

import "./style.scss";

export const AboutUs = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  // Team members data
  const teamMembers = [
    {
      id: 1,
      name: "Tahir Suleman",
      position: "Founder & Director",
      image: man4,
    },
    {
      id: 2,
      name: "Jan Michael",
      position: "Sales & Marketing",
      image: man2,
    },
    {
      id: 3,
      name: "Joni Mercado",
      position: "Sales Manager",
      image: man3,
    },
    {
      id: 4,
      name: "Muhammad Irfan",
      position: "Technical Manager",
      image: man1,
    },
    {
      id: 5,
      name: "Sharjeel Tahir",
      position: "Sales & Project Manager",
      image: man5,
    },
    {
      id: 6,
      name: "Ali Ismail",
      position: "AVL Technician",
      image: man6,
    },
  ];

  // Team member component
  const TeamMember = ({ member }) => (
    <Col lg={4} md={6} sm={12} className="mb-5 d-flex justify-content-center">
      <div className="text-center">
        <div className="position-relative d-inline-block mb-3 overflow-hidden rounded-4 shadow-lg bg-white">
          <Image 
            src={member.image} 
            alt={member.name}
            className="img-fluid"
            style={{
              width: '280px',
              height: '350px',
              objectFit: 'cover',
              objectPosition: 'center top',
              transition: 'transform 0.3s ease-in-out, filter 0.3s ease-in-out',
              cursor: 'pointer',
              display: 'block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.filter = 'brightness(1.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.filter = 'brightness(1)';
            }}
          />
        </div>
        <div className="mt-3">
          <h4 
            className="fw-bold text-uppercase mb-2"
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontSize: '1.5rem',
              letterSpacing: '0.5px',
              lineHeight: '1.2'
            }}
          >
            {member.name}
          </h4>
          <p 
            className="text-muted mb-0"
            style={{
              fontFamily: 'sans-serif',
              fontSize: '1rem',
              lineHeight: '1.4'
            }}
          >
            {member.position}
          </p>
        </div>
      </div>
    </Col>
  );

  return (
    <div>
      {/* Hero Section */}
      <div className="position-relative overflow-hidden" style={{ height: '500px' }}>
        <Image
          src={bgImg}
          alt="About Us Background"
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            objectFit: 'cover',
            zIndex: -1
          }}
        />
        <div className="aboutUs text-white position-relative h-100 d-flex flex-column justify-content-center align-items-center text-center px-3">
          <h1 className="about">ABOUT US</h1>
         <h2 className="discription">
          Welcome to Prime Events, Exhibitions & Productions, where we craft
          unforgettable
          <br />
          experiences tailored to your vision, turning moments into cherished
          memories.
        </h2>
        </div>
      </div>

      {/* Content Sections */}
      <div>
        {/* Our Story Section */}
        <div className="py-5 my-5">
          <OurStory />
        </div>

        <CultureContainer />

        {/* Our Clients Section */}
        <div className="py-5 my-5">
          <h2 className="heading2 text-center mb-5">Our Clients</h2>
          <ScrollSlider />
        </div>

        {/* Meet Our Team Section */}
        <Container fluid className="py-5 my-5">
          <h2 
            className="text-center mb-5 fw-bold text-uppercase"
            style={{
              fontSize: '2.5rem',
              letterSpacing: '1px'
            }}
          >
            Meet Our Team
          </h2>
          <Row className="justify-content-center g-4">
            {teamMembers.map((member) => (
              <TeamMember key={member.id} member={member} />
            ))}
          </Row>
        </Container>
      </div>

      <QueryModal show={show} handleClose={handleClose} />
    </div>
  );
};